/**
 * An error that occurs when the validation of a value fails.
 *
 * E.g. if a entered email is not valid because an missing @.
 */
export class ValidationError extends Error {}
